/**
 * Agent cursor opacity — how visible the agent's pointer is on the surface.
 *
 * The cursor is always drawn, never toggled, because a cursor that appears only
 * while the agent acts reads as a glitch. Resting opacity depends on who holds
 * control: dimmer while the human drives, since their own pointer is the one
 * that matters, and brighter while the agent holds it so its position stays
 * legible between actions.
 *
 * Ported from t3code (`apps/web/src/components/preview/agentBrowserCursorLogic.ts`).
 *
 * @module agentBrowserCursorLogic
 */
export type BrowserController = "human" | "agent" | "none";

export function agentBrowserCursorOpacity(active: boolean, controller: BrowserController): number {
  if (active) return 1;
  return controller === "human" ? 0.18 : 0.35;
}
